exports.default = {
  'build_ideas_with_ai': '用AI团队构建您的想法',
  'enter_your_question': '输入你的问题...',
  'upload_image': '上传图片',
  'invalid_image_format': '图片格式必须是 PNG、JPEG、JPG 或 WebP',
  'image_size_limit': '图片大小不能超过 20MB',
  'custom_agents': '自定义智能体',
  'all_agents': '全部智能体',
  'agent_tools_nav_label': '智能体功能入口',
  'content_creation': '内容创作',
  'all_agents_tip_1': '查看全部智能体与官方推荐',
  'all_agents_tip_2': '按场景筛选并进入对应智能体',
  'custom_agents_tip_1': '创建或管理自定义智能体',
  'custom_agents_tip_2': '沉淀你的专属工作流和团队能力',
  'ai_slides': 'AI 幻灯片',
  'ai_slides_prompt': '帮我生成一份演示文稿，主题是：',
  'ai_sheets': 'AI 表格',
  'ai_sheets_prompt': '帮我整理一张表格，内容是：',
  'ai_docs': 'AI 文档',
  'ai_docs_prompt': '帮我写一份文档，主题是：',
  'ai_designer': 'AI 设计师',
  'ai_designer_prompt': '帮我设计一个方案，需求是：',
  'ai_chat': 'AI 聊天',
  'ai_chat_prompt': '我想咨询：',
  'ai_image': 'AI 图片',
  'ai_image_prompt': '帮我生成一张图片，画面是：',
  'ai_music': 'AI 音乐',
  'ai_music_prompt': '帮我生成一段音乐创意，风格是：',
  'ai_video': 'AI 视频',
  'ai_video_prompt': '帮我生成一段视频脚本，主题是：',
  'ai_meeting': 'AI 纪要',
  'ai_meeting_prompt': '帮我整理会议纪要，内容是：',
  'unlimited_badge': '无限制',
  'text_agent_selector': '文本智能体胶囊选择',
  'text_agent_default_desc': '选择用于辅助理解需求的文本智能体',
  'no_text_agents': '暂无可用文本智能体',
  'web_entry_agent_missing': '暂无可用 AI 网页智能体入口',
  'agent_coming_soon': '敬请期待',
  'featured_cases': '精选案例',
  'recents': '最近',
  'view_all': '查看全部',
  'no_recents': '暂无最近案例',
  'more': '加载更多',
  'new_web_case': '新建网页案例',
  'featured_templates': '精选模板',
  'default': '默认',
  'latest': '最新',
  'popular': '热门',
  'all': '所有',
  'preview': '预览',
  'no_more_data': '没有更多数据了',
  'max_upload_images': '最多同时上传{count}张图片',
  'remixes': 'Remixes',
  'file_size_limit': '上传图片大小不能超过20M',
  'paste_content_too_long': '粘贴内容过长，已截取前{count}个字符',
  'content_too_long': '内容过长，已截取前{count}个字符',
  'short_text_insert_failed': '短文本插入失败',
  'chunk_insert_failed': '分片插入失败',
  'file_read_failed': '文件读取失败',
  'image_compress_failed': '图片压缩失败',
  'use_template': '使用模板',
  'use_template_desc': '使用此模板，您将创建一个属于您的副本。',
  'mode_title': '模式',
  'mode_desc': '设置 AI 模式。更快的模式消耗更少积分，更智能的模式效果更好。',
  'mode_recommended': '推荐',
  'mode_lite': 'Lite',
  'mode_lite_desc': '经济型选项，相同任务消耗更少积分。',
  'mode_standard': 'Standard',
  'mode_standard_desc': '适用于大多数任务。',
  'mode_ultra': 'Ultra',
  'mode_ultra_desc': '使用平台配置的最强模型，适合复杂推理和长任务。Ultra 模式将消耗更多积分。',
  'model_selector': '选择 Pai 模型',
  'selected_text_model': '所选文本模型',
  'model_reasoning': '推理',
  'model_image': '图片',
  'no_image_models': '暂无可用图片模型',
  'model_not_support_image': '当前模型不支持参考图，请更换模型或移除图片后再发送',
  'image_model_reference_limit': '当前图片模型最多支持 {count} 张参考图，请处理后再发送'
}
